import React, { Component } from 'react';
import {
    Typography,
    Grid,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    IconButton,
    Tooltip,
} from '@material-ui/core';
import { Button, FormControl, Card } from 'react-bootstrap';
import { PostData, GetData, DeleteData } from '../../api/service';
import Snack from '../Snackbar/Snack';
import FileUpload from '../AddNew/FileUpload';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';


class HomeBannerAdmin extends Component {
    state = {
        id: '',
        caption: '',
        file_info: [],
        data: [],
        isDataLoaded: false,
        loadFile: true,
        edit: false,
        open: false,
        message: '',
    };

    handleChange = (name, value) => {
        this.setState({ [name]: value });
    };

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    __getData = () => {
        GetData(`/${this.props.apikey}/banner/list`).then((resp) => {
            this.setState({
                data: Array.isArray(resp) ? resp : [],
                isDataLoaded: true,
            });
        });
    };

    componentDidMount() {
        this.__getData();
    }

    cancelEdit = () => {
        this.setState(
            {
                id: '',
                caption: '',
                file_info: [],
                edit: false,
                loadFile: false,
            },
            () => this.setState({ loadFile: true })
        );
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (!Array.isArray(this.state.file_info) || this.state.file_info.length === 0) {
            this.setState({ message: 'Please upload an image first.', open: true });
            return;
        }

        const payload = {
            caption: this.state.caption,
            file_info: this.state.file_info,
        };

        if (this.state.edit) {
            PostData(`/${this.props.apikey}/${this.state.id}/banner/update`, payload).then(
                (resp) => {
                    this.setState({ message: resp, open: true }, () => this.__getData());
                    this.cancelEdit();
                }
            );
        } else {
            PostData(`/${this.props.apikey}/banner/add`, payload).then((resp) => {
                this.setState({ message: resp, open: true }, () => this.__getData());
                this.cancelEdit();
            });
        }
    };

    onEditClick = (el) => {
        this.setState(
            {
                id: el.id,
                caption: el.caption || '',
                file_info: el.file_info || [],
                edit: true,
                loadFile: false,
            },
            () => this.setState({ loadFile: true })
        );
    };

    onDeleteClick = (el) => {
        confirmAlert({
            title: 'Confirm delete',
            message: 'Are you sure you want to delete this banner?',
            buttons: [
                { label: 'Yes', onClick: () => this.onDeleteConfirm(el.id) },
                { label: 'No' },
            ],
        });
    };

    onDeleteConfirm = (id) => {
        DeleteData(`/${this.props.apikey}/${id}/banner/delete`).then((resp) => {
            this.setState({ message: resp, open: true }, () => this.__getData());
        });
    };

    move = (index, direction) => {
        const data = [...this.state.data];
        const swapWith = index + direction;
        if (swapWith < 0 || swapWith >= data.length) return;

        [data[index], data[swapWith]] = [data[swapWith], data[index]];

        const ids = data.map((d) => d.id);
        this.setState({ data });
        PostData(`/${this.props.apikey}/banner/reorder`, { ids }).then(() => this.__getData());
    };

    thumbUrl = (el) => {
        if (!Array.isArray(el.file_info) || el.file_info.length === 0) return null;
        return el.file_info[0].url || null;
    };

    render() {
        return (
            <div>
                {this.state.open ? (
                    <Snack
                        open={this.state.open}
                        message={this.state.message}
                        handleClose={() =>
                            this.setState({ open: false, message: '' })
                        }
                    />
                ) : null}

                <form onSubmit={this.onSubmit}>
                    <Typography variant="h6" gutterBottom>
                        {this.state.edit ? 'Edit Banner' : 'Add Banner'}
                    </Typography>

                    <Card>
                        <Card.Body>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <label>Caption (optional)</label>
                                    <FormControl
                                        as="input"
                                        name="caption"
                                        onChange={this.onChange}
                                        value={this.state.caption}
                                        placeholder="Caption shown over the banner"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <label>Banner Image *</label>
                                    {this.state.loadFile ? (
                                        <FileUpload
                                            dp={this.state.file_info}
                                            type={'HOME_BANNER'}
                                            setDp={this.handleChange.bind(this, 'file_info')}
                                        />
                                    ) : null}
                                    <small style={{ color: '#888' }}>
                                        Image only (JPG / PNG). Use the same aspect ratio across banners for a uniform carousel.
                                    </small>
                                </Grid>
                            </Grid>

                            <div align="right" style={{ marginTop: 10 }}>
                                {this.state.edit ? (
                                    <span>
                                        <Button
                                            size="sm"
                                            variant="danger"
                                            type="submit"
                                        >
                                            Update
                                        </Button>
                                        &nbsp;
                                        <Button
                                            size="sm"
                                            variant="secondary"
                                            type="button"
                                            onClick={this.cancelEdit}
                                        >
                                            Cancel
                                        </Button>
                                    </span>
                                ) : (
                                    <Button
                                        size="sm"
                                        variant="info"
                                        type="submit"
                                    >
                                        Add Banner
                                    </Button>
                                )}
                            </div>
                        </Card.Body>
                    </Card>

                    <br />

                    <Card>
                        <Card.Body>
                            <Typography variant="h6" gutterBottom>
                                Banners (top → first in carousel)
                            </Typography>

                            {!this.state.isDataLoaded ? (
                                <Typography>Loading…</Typography>
                            ) : this.state.data.length === 0 ? (
                                <Typography style={{ color: '#888' }}>
                                    No banners yet. Add one above.
                                </Typography>
                            ) : (
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width="60">#</TableCell>
                                            <TableCell width="140">Preview</TableCell>
                                            <TableCell>Caption</TableCell>
                                            <TableCell width="120">Order</TableCell>
                                            <TableCell width="60">Edit</TableCell>
                                            <TableCell width="60">Delete</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.data.map((el, index) => {
                                            const url = this.thumbUrl(el);
                                            return (
                                                <TableRow key={el.id}>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>
                                                        {url ? (
                                                            <img
                                                                src={url}
                                                                alt=""
                                                                style={{
                                                                    width: 120,
                                                                    height: 70,
                                                                    objectFit: 'cover',
                                                                    borderRadius: 4,
                                                                }}
                                                            />
                                                        ) : (
                                                            <span style={{ color: '#bbb' }}>—</span>
                                                        )}
                                                    </TableCell>
                                                    <TableCell>{el.caption || <span style={{ color: '#bbb' }}>—</span>}</TableCell>
                                                    <TableCell>
                                                        <Tooltip title="Move up">
                                                            <span>
                                                                <IconButton
                                                                    size="small"
                                                                    disabled={index === 0}
                                                                    onClick={() => this.move(index, -1)}
                                                                >
                                                                    <ArrowUpward fontSize="small" />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                        <Tooltip title="Move down">
                                                            <span>
                                                                <IconButton
                                                                    size="small"
                                                                    disabled={index === this.state.data.length - 1}
                                                                    onClick={() => this.move(index, 1)}
                                                                >
                                                                    <ArrowDownward fontSize="small" />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Edit onClick={this.onEditClick.bind(this, el)} style={{ cursor: 'pointer' }} />
                                                    </TableCell>
                                                    <TableCell>
                                                        <Delete onClick={this.onDeleteClick.bind(this, el)} style={{ cursor: 'pointer' }} />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            )}
                        </Card.Body>
                    </Card>
                </form>
            </div>
        );
    }
}

export default HomeBannerAdmin;



// WEBPACK FOOTER //
// ./src/Components/HomeBanner/HomeBannerAdmin.js